import encodeAudio from './encode-audio';

export default function handleAudioUploadCompleted(episodeId, mediaUrl) {
  return encodeAudio(episodeId, mediaUrl);
}

// eslint-disable-next-line camelcase
global.test__handleAudioUploadCompleted = handleAudioUploadCompleted;
